import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { NavLink } from "react-router-dom";

const ArrangeOrderModalV2 = ({
  showModal,
  setShowModal,
  passer,
  customerDetailsArr,
  setCustomerDetailsArr,
  orignalRidePattern,
  setOrignalRidePattern,
  returnRidePattern,
  setReturnRidePattern,
  setIsRidePatternArranged,
}) => {
  const students = useSelector((x) => x.students);

  const [selectedTab, setSelectedTab] = useState("Pick");

  const handleSubmit = async (event) => {
    event.preventDefault();
    setIsRidePatternArranged(true);

    setShowModal(false);
  };

  const swapPickupArr = (index1, index2) => {
    setOrignalRidePattern((array) => {
      let data = [...array];
      let temp = data[index1];
      data[index1] = data[index2];
      data[index2] = temp;
      return data;
    });
  };

  const swapDropffArr = (index1, index2) => {
    setReturnRidePattern((array) => {
      let data = [...array];
      let temp = data[index1];
      data[index1] = data[index2];
      data[index2] = temp;
      return data;
    });
  };

  useEffect(() => {
    if (
      orignalRidePattern.length == 0 ||
      orignalRidePattern.length != customerDetailsArr.length * 2
    ) {
      let tempOrignalRouteArr = [];
      // for (let i = 0; i < customerDetailsArr.length; i++) {
      //   tempOrignalRouteArr.push({ ...customerDetailsArr[i], routeType: "Pick" });
      //   tempOrignalRouteArr.push({ ...customerDetailsArr[i], routeType: "Drop" });
      // }

      for (let i = 0; i < customerDetailsArr.length; i++) {
        tempOrignalRouteArr.push({
          customerId: customerDetailsArr[i].customerId,
          address: customerDetailsArr[i].pickUpAddress,
          time: customerDetailsArr[i].pickUpTime,
          customerDetails: customerDetailsArr[i],

          routeType: "Pick",
        });
        tempOrignalRouteArr.push({
          customerId: customerDetailsArr[i].customerId,
          address: customerDetailsArr[i].dropOffAddress,
          time: customerDetailsArr[i].dropOffTime,
          customerDetails: customerDetailsArr[i],

          routeType: "Drop",
        });
      }

      setOrignalRidePattern(tempOrignalRouteArr);
    }
  }, [customerDetailsArr]);

  useEffect(() => {
    if (
      returnRidePattern.length == 0 ||
      returnRidePattern.length !==
        customerDetailsArr.filter((x) => x.returnRoute).length * 2
    ) {
      let tempReturnRouteArr = [];

      // // tempReturnRouteArr.reverse();

      // for (let i = 0; i < customerDetailsArr.length; i++) {
      //   tempReturnRouteArr.push({ ...customerDetailsArr[i], routeType: "Drop" });
      //   tempReturnRouteArr.push({ ...customerDetailsArr[i], routeType: "Pick" });
      // }

      for (let i = 0; i < customerDetailsArr.length; i++) {
        tempReturnRouteArr.push({
          customerId: customerDetailsArr[i].customerId,
          address: customerDetailsArr[i].dropOffAddress,
          time: customerDetailsArr[i].dropOffTime,
          customerDetails: customerDetailsArr[i],
          routeType: "Drop",
        });

        tempReturnRouteArr.push({
          customerId: customerDetailsArr[i].customerId,
          address: customerDetailsArr[i].pickUpAddress,
          time: customerDetailsArr[i].pickUpTime,
          customerDetails: customerDetailsArr[i],

          routeType: "Pick",
        });
      }

      tempReturnRouteArr.reverse();

      setReturnRidePattern(tempReturnRouteArr);
    }
  }, [customerDetailsArr]);

  // useEffect(() => {
  //   setIsRidePatternArranged(true);
  // }, []);

  return (
    <>
      <div
        className={`modal fade ${showModal ? "show modal-y-axis" : "hide"}`}
        role="dialog"
      >
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLongTitle">
                {" "}
                Ride Pattern
              </h5>
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
                // onClick={() => openDropDown()}
                onClick={() => setShowModal(false)}
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body ">
              <div className="row">
                <div className="col-12 col-md-4">
                  <h6>Students List</h6>
                  <ul className="">
                    {customerDetailsArr.map((x, i) => {
                      const studentFound = students?.list?.find(
                        (customer) => customer.id === x.customerId
                      );
                      return (
                        <li className=" bg-grey rounded p-2 my-1">
                          {`${i + 1} ) 
                          ${
                            // x.student
                            studentFound
                              ? `${studentFound.firstName} ${studentFound.lastName}`
                              : "Student not selected"
                          }`}
                        </li>
                      );
                    })}
                  </ul>
                </div>
                <div className="col-12 col-md-8">
                  <div className="row align-items-center">
                    <div className="col-12 ">
                      <ul className="nav nav-pills nav-justified">
                        <li
                          onClick={() => setSelectedTab("Pick")}
                          className={`nav-item  border p-2 cursor-pointer bg-primary text-white ${
                            selectedTab === "Pick"
                              ? "bg-primary"
                              : "bg-secondary"
                          }`}
                        >
                          {/* <NavLink
                            to=""
                            // onClick={() => dispatch(tabBaseLocation())}
                            className=""
                          > */}
                          Orignal Ride
                          {/* </NavLink> */}
                        </li>
                        <li
                          onClick={() => setSelectedTab("Drop")}
                          className={`nav-item border p-2 cursor-pointer text-white ${
                            selectedTab === "Drop"
                              ? "bg-primary"
                              : "bg-secondary"
                          }`}
                        >
                          {/* <NavLink
                            to=""
                            // onClick={() => dispatch(tabAddServices())}
                            className=""
                          > */}
                          Return Ride
                          {/* </NavLink> */}
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div className="row pt-2">
                    {selectedTab === "Pick" ? (
                      <>
                        {orignalRidePattern.map((x, i) => {
                          const studentFound = students?.list?.find(
                            (customer) => customer.id == x.customerId
                          );
                          return (
                            <div className="col-12 mb-1">
                              <div className="bg-grey p-1 d-flex justify-content-between align-items-center">
                                <p className="m-0">
                                  {`${i + 1}) ${x.routeType} ${
                                    // x.student
                                    studentFound
                                      ? `${studentFound.firstName} ${studentFound.lastName}`
                                      : "Student not selected"
                                  }
                          
                        `}
                                </p>

                                <div>
                                  {i !== 0 ? (
                                    <>
                                      {x.routeType === "Drop" ? (
                                        orignalRidePattern
                                          .slice(0, i - 1)
                                          .find(
                                            (z) =>
                                              z.routeType === "Pick" &&
                                              z.customerId === x.customerId
                                          ) ? (
                                          <button
                                            className="btn btn-md"
                                            onClick={() =>
                                              swapPickupArr(i, i - 1)
                                            }
                                          >
                                            <i className="bi bi-chevron-up text-primary"></i>
                                          </button>
                                        ) : (
                                          <button
                                            className="btn btn-md"
                                            disabled
                                          >
                                            <i className="bi bi-chevron-up"></i>
                                          </button>
                                        )
                                      ) : orignalRidePattern
                                          .slice(i, orignalRidePattern.length)
                                          .find(
                                            (z) =>
                                              z.routeType === "Drop" &&
                                              z.customerId === x.customerId
                                          ) ? (
                                        <button
                                          className="btn btn-md"
                                          onClick={() =>
                                            swapPickupArr(i, i - 1)
                                          }
                                        >
                                          <i className="bi bi-chevron-up text-primary"></i>
                                        </button>
                                      ) : (
                                        <button className="btn btn-md" disabled>
                                          <i className="bi bi-chevron-up"></i>
                                        </button>
                                      )}
                                    </>
                                  ) : (
                                    <button className="btn btn-md" disabled>
                                      <i className="bi bi-chevron-up"></i>
                                    </button>
                                  )}

                                  {i !== orignalRidePattern.length - 1 ? (
                                    <>
                                      {x.routeType === "Drop" ? (
                                        orignalRidePattern
                                          .slice(0, i + 1)
                                          .find(
                                            (z) =>
                                              z.routeType === "Pick" &&
                                              z.customerId === x.customerId
                                          ) ? (
                                          <button
                                            className="btn btn-md"
                                            onClick={() =>
                                              swapPickupArr(i, i + 1)
                                            }
                                          >
                                            <i className="bi bi-chevron-down text-primary"></i>
                                          </button>
                                        ) : (
                                          <button
                                            className="btn btn-md"
                                            disabled
                                          >
                                            <i className="bi bi-chevron-down"></i>
                                          </button>
                                        )
                                      ) : orignalRidePattern
                                          .slice(
                                            i + 2,
                                            orignalRidePattern.length
                                          )
                                          .find(
                                            (z) =>
                                              z.routeType === "Drop" &&
                                              z.customerId === x.customerId
                                          ) ? (
                                        <button
                                          className="btn btn-md"
                                          onClick={() =>
                                            swapPickupArr(i, i + 1)
                                          }
                                        >
                                          <i className="bi bi-chevron-down text-primary"></i>
                                        </button>
                                      ) : (
                                        <button className="btn btn-md" disabled>
                                          <i className="bi bi-chevron-down"></i>
                                        </button>
                                      )}
                                    </>
                                  ) : (
                                    <button className="btn btn-md" disabled>
                                      <i className="bi bi-chevron-down"></i>
                                    </button>
                                  )}
                                </div>
                              </div>
                            </div>
                          );
                        })}
                      </>
                    ) : (
                      <>
                        {returnRidePattern.map((x, i) => {
                          const studentFound = students?.list?.find(
                            (customer) => customer.id === x.customerId
                          );
                          return (
                            <div className="col-12 mb-1">
                              <div className="bg-grey p-1 d-flex justify-content-between align-items-center">
                                <p className="m-0">
                                  {`${i + 1}) ${x.routeType} ${
                                    // x.student
                                    studentFound
                                      ? `${studentFound.firstName} ${studentFound.lastName}`
                                      : "Student not selected"
                                  }
                        `}
                                </p>

                                <div>
                                  {i !== 0 ? (
                                    <>
                                      {x.routeType == "Drop" ? (
                                        returnRidePattern
                                          .slice(0, i - 1)
                                          .find(
                                            (z) =>
                                              z.routeType === "Pick" &&
                                              z.customerId === x.customerId
                                          ) ? (
                                          <button
                                            className="btn btn-md"
                                            onClick={() =>
                                              swapDropffArr(i, i - 1)
                                            }
                                          >
                                            <i className="bi bi-chevron-up text-primary"></i>
                                          </button>
                                        ) : (
                                          <button
                                            className="btn btn-md"
                                            disabled
                                          >
                                            <i className="bi bi-chevron-up"></i>
                                          </button>
                                        )
                                      ) : returnRidePattern
                                          .slice(i, returnRidePattern.length)
                                          .find(
                                            (z) =>
                                              z.routeType === "Drop" &&
                                              z.customerId === x.customerId
                                          ) ? (
                                        <button
                                          className="btn btn-md"
                                          onClick={() =>
                                            swapDropffArr(i, i - 1)
                                          }
                                        >
                                          <i className="bi bi-chevron-up text-primary"></i>
                                        </button>
                                      ) : (
                                        <button className="btn btn-md" disabled>
                                          <i className="bi bi-chevron-up"></i>
                                        </button>
                                      )}
                                    </>
                                  ) : (
                                    <button className="btn btn-md" disabled>
                                      <i className="bi bi-chevron-up"></i>
                                    </button>
                                  )}

                                  {i !== returnRidePattern.length - 1 ? (
                                    <>
                                      {x.routeType === "Drop" ? (
                                        returnRidePattern
                                          .slice(0, i + 1)
                                          .find(
                                            (z) =>
                                              z.routeType === "Pick" &&
                                              z.customerId === x.customerId
                                          ) ? (
                                          <button
                                            className="btn btn-md"
                                            onClick={() =>
                                              swapDropffArr(i, i + 1)
                                            }
                                          >
                                            <i className="bi bi-chevron-down text-primary"></i>
                                          </button>
                                        ) : (
                                          <button
                                            className="btn btn-md"
                                            disabled
                                          >
                                            <i className="bi bi-chevron-down"></i>
                                          </button>
                                        )
                                      ) : returnRidePattern
                                          .slice(
                                            i + 2,
                                            returnRidePattern.length
                                          )
                                          .find(
                                            (z) =>
                                              z.routeType === "Drop" &&
                                              z.customerId === x.customerId
                                          ) ? (
                                        <button
                                          className="btn btn-md"
                                          onClick={() =>
                                            swapDropffArr(i, i + 1)
                                          }
                                        >
                                          <i className="bi bi-chevron-down text-primary"></i>
                                        </button>
                                      ) : (
                                        <button className="btn btn-md" disabled>
                                          <i className="bi bi-chevron-down"></i>
                                        </button>
                                      )}
                                    </>
                                  ) : (
                                    <button className="btn btn-md" disabled>
                                      <i className="bi bi-chevron-down"></i>
                                    </button>
                                  )}
                                </div>
                              </div>
                            </div>
                          );
                        })}{" "}
                      </>
                    )}
                  </div>
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn-secondary rounded f-14 p-2 mr-3"
                data-dismiss="modal"
                onClick={() => setShowModal(false)}
              >
                Close
              </button>
              <button
                type="submit"
                className="btn-primary rounded f-14 p-2 mr-3"
                onClick={handleSubmit}
              >
                Submit
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default ArrangeOrderModalV2;
